/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-return-assign */
import React, { useEffect, useRef, useState } from 'react';
import { Image } from 'components/atoms/Image/Image';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Icon } from '@chakra-ui/react';
import { useCart } from 'context/cartContext';
import { useAuth } from 'context/AuthContext';
import { trackComponentInteraction } from 'libs/adobeAnalytics';
import { RCM_DOWNLOAD_LINK } from 'constants';
import { useIsMobile } from 'helpers/ui';

const ACCOUNT_LINKS = [
  { name: 'Account', href: `${process.env.REACT_APP_DETAILS_REDIRECT}` },
  { name: 'Profile', href: `${process.env.REACT_APP_SITE_URL}backstage/settings#profile` },
  { name: 'Settings', href: `${process.env.REACT_APP_SITE_URL}backstage/settings#settings` },
];

export function Header() {
  const user = useSelector((state) => state.user.userInfo);
  const { signinRedirect, signoutRedirect } = useAuth();
  const burgerRef = useRef(null);
  const navRef = useRef(null);
  const navLinksRef = useRef([]);
  /* Refs for account sub-menu */
  const accountButtonRef = useRef(null);
  const accountSubMenuRef = useRef(null);
  const accountLinksRef = useRef([]);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const isMobile = useIsMobile(1366);

  const navigate = useNavigate();

  useEffect(() => {
    if (isMenuOpen) {
      setIsMenuVisible(true);
    }
  }, [isMenuOpen]);

  useEffect(() => {
    const accountLinks = accountLinksRef.current;

    accountLinks.forEach((link, index) => {
      if (link) {
        if (isSubMenuOpen) {
          link.style.animation = `navLinkFade 0.35s ease forwards ${index / 10}s`;
        } else {
          link.style.animation = '';
        }
      }
    });
  }, [isSubMenuOpen]);

  const links = [
    { name: 'Shop', href: '/' },
    { name: 'News', href: process.env.REACT_APP_NEWS_URL },
    { name: 'Memberships', href: process.env.REACT_APP_MEMBERSHIPS_PAGE },
    { name: 'Support', href: process.env.REACT_APP_SUPPORT_URL },
    { name: 'About', href: process.env.REACT_APP_ABOUT_URL },
  ];

  const { cart } = useCart();

  const lastItemRef = useRef(null);
  const lastFocusedIndex = useRef(-1);

  useEffect(() => {
    const navLinks = navLinksRef.current;

    navLinks.forEach((link, index) => {
      if (link) {
        if (isMenuOpen) {
          link.style.animation = `navLinkFade 0.5s ease forwards ${index / 18}s`;
        } else {
          link.style.animation = '';
        }
      }
    });

    if (isMenuOpen) {
      const firstLink = navLinks[0]?.querySelector('a');
      if (firstLink) {
        setTimeout(() => firstLink.focus(), 100);
      }
    } else if (document.activeElement && navRef.current && navRef.current.contains(document.activeElement)) {
      burgerRef.current?.focus();
    } else if (document.activeElement === document.body) {
      if (burgerRef.current) {
        burgerRef.current.focus();
      }
    }
  }, [isMenuOpen]);

  // Close hamburger menu with Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (isMenuOpen && e.key === 'Escape') {
        setIsMenuOpen(false);
        burgerRef.current?.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isMenuOpen]);

  const toggleAccountMenu = () => {
    if (isMenuOpen) setIsMenuOpen(false);
    setIsSubMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const nav = navRef.current;
      const burger = burgerRef.current;
      const accountSubMenu = accountSubMenuRef.current;
      const accountButton = accountButtonRef.current;
      const accountLinks = accountLinksRef.current;

      // Close main nav menu if click outside
      if (
        nav
        && burger
        && isMenuOpen
        && !nav.contains(event.target)
        && !burger.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }

      // Close account sub-menu if click outside
      if (
        accountSubMenu
        && accountButton
        && accountSubMenu.classList.contains('account-active')
        && !accountSubMenu.contains(event.target)
        && !accountButton.contains(event.target)
      ) {
        accountLinks.forEach((link) => {
          if (link) {
            link.style.animation = '';
          }
        });
        accountSubMenu.classList.toggle('account-active');
        accountButton.classList.toggle('toggle');
        setIsSubMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isMenuOpen]);

  const handleShopLinkClick = () => {
    setIsMenuOpen(false);
  };

  const logoutUser = () => {
    signoutRedirect();
  };

  const goToCart = () => {
    trackComponentInteraction('component.click', {
      info: {
        name: 'Go to Cart',
        location: 'Top navigation bar - Cart icon',
        url: `${process.env.REACT_APP_PUBLIC_URL}/checkout`,
        intentAction: false,
      },
    });
    navigate('/checkout');
  };

  return (
    <header className='header' id='header'>
      <div className='header__container'>
        <div className='header__logoContainer'>
          <button
            className={`burger ${isMenuOpen ? 'toggle' : ''} focus:ring-2 focus:ring-[#39A9F7] focus:ring-offset-2 outline-none rounded-md`}
            ref={burgerRef}
            type='button'
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-expanded={isMenuOpen}
            aria-controls='nav-links-list'
          >
            <div className='line1' />
            <div className='line2' />
            <div className='line3' />
          </button>
          <div className='header__logo'>
            <a
              href={process.env.REACT_APP_HOME || window.location.origin}
              onKeyDown={(e) => {
                if (e.key === ' ') {
                  e.preventDefault();
                  e.currentTarget.click();
                }
              }}
            >
              <Image
                name='Roland_Cloud_Official_White-grad.webp'
                alt='logo'
                width={240}
                height={28}
              />
            </a>
          </div>
        </div>
        <nav aria-label='Main menu'>
          {(!isMobile || isMenuOpen) && (
          <ul
            className={`nav-links ${isMobile ? isMenuOpen ? 'nav-active' : 'nav-inactive' : ''}`}
            ref={navRef}
            id='nav-links-list'
            aria-hidden={!isMenuOpen && isMobile}
            onTransitionEnd={(e) => {
              if (!isMenuOpen && e.propertyName === 'transform') {
                setIsMenuVisible(false);
              }
            }}
            style={isMobile ? {
              visibility: isMenuOpen ? 'visible' : 'hidden',
              pointerEvents: isMenuOpen ? 'auto' : 'none',
            } : {}}
            onBlur={(e) => {
              if (isMenuOpen && !e.currentTarget.contains(e.relatedTarget) && !burgerRef.current?.contains(e.relatedTarget) && e.relatedTarget !== null) {
                setIsMenuOpen(false);
              }
            }}
          >
            {links.map((link, index) => {
              const isLast = index === links.length - 1;
              const lastIndex = links.length - 1;

              return (
                <li
                  style={isMobile ? {
                    display: isMenuVisible ? '' : 'none',
                  } : {}}
                  key={index}
                  ref={(el) => (navLinksRef.current[index] = el)}
                >
                  {link.href.startsWith('http') ? (
                    <a
                      href={link.href}
                      tabIndex={isMobile ? isMenuOpen ? 0 : -1 : 0}
                      aria-hidden={!isMenuOpen && isMobile}
                      ref={isLast ? lastItemRef : null}
                      onFocus={() => {
                        const currentIndex = index;

                        if (lastFocusedIndex.current === lastIndex
                          && currentIndex === lastIndex) {
                          setIsMenuOpen(false);

                          setTimeout(() => {
                            burgerRef.current?.focus();
                          }, 0);
                        }

                        lastFocusedIndex.current = currentIndex;
                      }}
                      onKeyDown={(e) => {
                        if (e.key === ' ') {
                          e.preventDefault();
                          e.currentTarget.click();
                        }
                      }}
                    >
                      {link.name}
                    </a>
                  ) : (
                    <Link
                      to={link.href}
                      tabIndex={isMobile ? (isMenuOpen ? 0 : -1) : 0}
                      onClick={link.name === 'Shop' ? handleShopLinkClick : undefined}
                      onKeyDown={(e) => {
                        if (e.key === ' ') {
                          e.preventDefault();
                          e.currentTarget.click();
                        }
                      }}
                    >
                      {link.name}
                    </Link>
                  )}
                </li>
              );
            })}

            <li>
              <button
                tabIndex={isMenuOpen ? 0 : -1}
                style={{
                  position: 'absolute',
                  width: 1,
                  height: 1,
                  opacity: 0,
                }}
                onFocus={() => {
                  setIsMenuOpen(false);
                  burgerRef.current?.focus();
                }}
              />
            </li>
          </ul>
          )}
        </nav>
        <div className='header__auth'>
          <ul className='header__auth-list'>
            <li className='header__auth-item__pill' id='rcmDownload'>
              <a
                className='flex justify-center items-center gap-2'
                href={RCM_DOWNLOAD_LINK}
                onKeyDown={(e) => {
                  if (e.key === ' ') {
                    e.preventDefault();
                    e.currentTarget.click();
                  }
                }}
              >
                Roland Cloud Manager
                <Icon className='inline-block'>
                  <svg className='size-4' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <g clipPath='url(#clip0_67_1019)'>
                      <path d='M22.5 16V20.6667C22.5 21.2855 22.2542 21.879 21.8166 22.3166C21.379 22.7542 20.7855 23 20.1667 23H3.83333C3.21449 23 2.621 22.7542 2.18342 22.3166C1.74583 21.879 1.5 21.2855 1.5 20.6667V16' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path d='M6 10L12 16L18 10' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path d='M12 16V1' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                    </g>
                    <defs>
                      <clipPath id='clip0_67_1019'>
                        <rect width='24' height='24' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>
                </Icon>
              </a>
            </li>
            {user?.guest ? (
              <li className='header__auth-item__pill font-bold'>
                <button
                  type='button'
                  className='bold-tag'
                  onClick={() => signinRedirect()}
                >
                  Sign in
                </button>
              </li>
            ) : (
              <>
                <li className='header__auth-item__logged-in'>
                  <button
                    ref={accountButtonRef}
                    className='header__auth-item__logged-in--btn focus:ring-2 focus:ring-[#39A9F7] focus:ring-offset-2 outline-none rounded-full'
                    type='button'
                    onClick={toggleAccountMenu}
                    aria-label='My Account'
                    aria-expanded={isSubMenuOpen}
                    aria-controls='account-sub-menu'
                    style={{
                      background: 'none', border: 'none', padding: 0, cursor: 'pointer', display: 'flex',
                    }}
                  >
                    <div className='header__auth-item__logged-in--el p-1'>
                      <Icon>
                        <svg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                          <path d='M17 19V17C17 15.9391 16.5786 14.9217 15.8284 14.1716C15.0783 13.4214 14.0609 13 13 13H5C3.93913 13 2.92172 13.4214 2.17157 14.1716C1.42143 14.9217 1 15.9391 1 17V19M13 5C13 7.20914 11.2091 9 9 9C6.79086 9 5 7.20914 5 5C5 2.79086 6.79086 1 9 1C11.2091 1 13 2.79086 13 5Z' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                        </svg>
                      </Icon>
                    </div>
                  </button>
                </li>
                {isSubMenuOpen && (
                <ul
                  className='account-links account-active'
                  ref={accountSubMenuRef}
                  id='account-sub-menu'
                  aria-hidden={isMobile && isSubMenuOpen ? undefined : 'true'}
                  style={{
                    visibility: isSubMenuOpen ? 'visible' : 'hidden',
                    pointerEvents: isSubMenuOpen ? 'auto' : 'none',
                  }}
                  onBlur={(e) => {
                    if (isSubMenuOpen && !e.currentTarget.contains(e.relatedTarget) && !accountButtonRef.current?.contains(e.relatedTarget) && e.relatedTarget !== null) {
                      toggleAccountMenu();
                    }
                  }}
                >
                  {ACCOUNT_LINKS.map((link, index) => (
                    <li
                      key={index}
                      ref={(el) => (accountLinksRef.current[index] = el)}
                    >
                      <a
                        href={link.href}
                        tabIndex={isSubMenuOpen ? 0 : -1}
                        className='focus:ring-2 focus:ring-[#39A9F7] focus:ring-offset-2 outline-none rounded-sm'
                        onKeyDown={(e) => {
                          if (e.key === ' ') {
                            e.preventDefault();
                            e.currentTarget.click();
                          }
                        }}
                      >
                        {link.name}
                      </a>
                    </li>
                  ))}
                  <li
                    key='logout'
                    ref={(el) => (accountLinksRef.current[ACCOUNT_LINKS.length] = el)}
                  >
                    <button
                      className='button-logout focus:ring-2 focus:ring-[#39A9F7] focus:ring-offset-2 outline-none rounded-sm'
                      type='button'
                      onClick={() => logoutUser()}
                      tabIndex={isSubMenuOpen ? 0 : -1}
                    >
                      Log Out
                    </button>
                  </li>
                </ul>
                )}
              </>
            )}
            <li>
              <button
                className='header__auth-item__cart focus:ring-2 focus:ring-[#39A9F7] focus:ring-offset-2 outline-none rounded-md'
                onClick={() => goToCart()}
                type='button'
                aria-label='View shopping cart'
              >
                <Icon>
                  <svg className='size-6' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                    <path d='M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                    <path d='M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                  </svg>
                </Icon>
                {cart.length > 0 ? (
                  <p
                    className='header__auth-item__cart-badge'
                  >
                    {cart?.length}
                  </p>
                ) : null}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}
